export default {
  superadmin: {
    description: 'Superuser',
    value: 'superadmin'
  },
  standard: {
    description: 'Standard',
    value: 'standard'
  }
}
